<div class="root-container">
  <nav class="navbar" [class.hidden]="navTransparent && inHomePage">
    <a routerLink="/" class="logo_container">
      <img src="assets/images/brand-logo.png" class="logo" alt="PHILIPPINE VEX ROBOTICS" />
    </a>
    <div class="link_items">
      <div class="links" [class.active]="menuOpen">
        <a [href]="liveUrl"  [class]="hasLive ? 'live navbar-link' : 'navbar-link'" id="live-link" target="_blank">Live</a>
        <a routerLink="/" class="navbar-link" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Home</a>
        <a routerLink="/events" class="navbar-link" routerLinkActive="active-link">Events</a>
        <div class="dropdown">
          <button class="navbar-link text-start" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            More Information
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <ul class="dropdown-menu bg-black">
            <li><a routerLink="/awards" class="navbar-link dropdown-item" routerLinkActive="active-link">Awards</a></li>
            <li><a routerLink="/apparel" class="navbar-link dropdown-item" routerLinkActive="active-link">Aparrel</a></li>
            <li><a routerLink="/volunteer" class="navbar-link dropdown-item" routerLinkActive="active-link">Volunteer</a></li>
            <li><a routerLink="/gallery" class="dropdown-item navbar-link" routerLinkActive="active-link">Gallery</a></li>
            <li><a routerLink="/download" class="dropdown-item navbar-link" routerLinkActive="active-link">Download</a></li>
            <li><a routerLink="/registration" class="dropdown-item navbar-link" routerLinkActive="active-link">Registration</a></li>
            <li><a routerLink="/contact-us" class="dropdown-item navbar-link" routerLinkActive="active-link">Contact Us</a></li>
          </ul>
        </div>
      </div>
      <!-- <div id="search_icon">
        <i class="icon fa-solid fa-magnifying-glass"></i>
      </div> -->
      <div id="menu_bar" (click)="toggleMenu()">
        <i class="icon fa-solid fa-bars"></i>
      </div>
    </div>
  </nav>
</div>
